import React from 'react'
import ContentfulJsonLdBlocks from '../src/components/shared/ContentfulJsonLdBlocks'
import Layout from 'src/components/layouts'
import defaultSEO from 'src/common/constants/nextSEO'
import { data } from 'src/components/pages/Home/consts'
import HomePage from 'src/components/pages/Home/default'
import WithSeoOverrides from 'src/components/shared/WithSeoOverride'
import { getHomePageData } from 'src/common/getHomePageData'
import { getMegamenuData } from 'src/common/back/megamenu'
import logger from 'src/common/logger'

export async function getServerSideProps(context) {
  const {
    cfosData,
    trustMarker,
    trustMarkersCombination,
    trustPilotInfo,
    outageBanner,
    jsonLdSchemas,
  } = await getHomePageData(context?.preview ?? false, {
    combinationId: 'control',
    jsonLdPath: '/',
  })

  let megamenuData = null
  try {
    megamenuData = await getMegamenuData(context)
  } catch (error) {
    logger.error('Home page: Ups something bad happens', {
      error,
    })
  }

  return {
    props: {
      homeVariation: 'control',
      cfosData,
      trustMarker,
      trustMarkersCombination: trustMarkersCombination || null,
      trustPilotInfo: trustPilotInfo || null,
      outageBanner: outageBanner || null,
      megamenuData: megamenuData || null,
      jsonLdSchemas,
    },
  }
}

// Control page
const Index = (pageProps) => {
  const {
    homeVariation,
    cfosData,
    trustMarkersCombination,
    trustPilotInfo,
    outageBanner,
    megamenuData,
    jsonLdSchemas,
  } = pageProps

  return (
    <>
      <WithSeoOverrides {...defaultSEO} />
      <ContentfulJsonLdBlocks jsonLdSchemas={jsonLdSchemas} />
      <Layout
        isBrandPage={true}
        isHome={true}
        homeVariation={homeVariation}
        forceFullRequest={true}
        outageBanner={outageBanner}
        megamenuData={megamenuData}
      >
        <HomePage
          data={{
            ...data,
            heroBanner: {
              ...data.heroBanner,
              content: {
                title: 'Get rid of credit card debt',
                sliderTitle: 'How much do you owe?',
                buttonText: 'Continue',
              },
            },
            showBarChart: true,
            cfosData,
            isCfosDisclousuresVariationActive: true,
            trustMarkersCombination,
            useTestimonialFormat: true,
            trustPilotInfo,
          }}
        />
      </Layout>
    </>
  )
}

export default Index
